<template>
    <div class="user">
        <div @click="emitOpenProfileEvent">
            <avatar
                :size="70"
                class="picture"
                :src="user.picture"
                :username="user.name"
            />
        </div>
        <span class="name" @click="emitOpenProfileEvent">{{ user.name }}</span>
        <div class="teams">
            <div :key="team.id" v-for="team in teams">{{ team.name }}</div>
        </div>
    </div>
</template>
<script>
import Avatar from 'vue-avatar'
import { getUserTeams } from './api'
export default {
    components: {
        Avatar,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            teams: [],
        }
    },
    mounted() {
        this.getUserTeams()
    },
    methods: {
        emitOpenProfileEvent() {
            this.$emit('open-profile')
        },
        getUserTeams() {
            this.teams = []
            getUserTeams(this.user.id).then((teams) => {
                this.teams = teams
            })
        },
    },
    watch: {
        'user.id': function () {
            this.getUserTeams()
        },
    },
}
</script>
<style lang="scss" scoped>
.user {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 10px;

    .picture {
        cursor: pointer;
        margin-bottom: 5px;
    }

    .name {
        cursor: pointer;
        font-size: 19px;
        color: #009bdb;

        &:hover {
            text-decoration: underline;
        }
    }

    .teams {
        color: #666666;
        font-weight: 500;
    }
}
</style>
